import { QueryConstraint, Unsubscribe } from "firebase/firestore";
import Command from "../entities/stores/command";
import FirestorePipe from "../utils/pipe";
import EstablishmentDB from "./establishment";

class CommandDB extends FirestorePipe {

  public static readonly colName = 'Commands'

  constructor(idEstab: string) {
    if(!idEstab)
      throw new Error('Informe o id da loja e do estabelecimento')
    super(`${EstablishmentDB.colName}/${idEstab}/${CommandDB.colName}`);
  }

  public create(data: Command): Promise<any> {
    throw new Error('Method not exists')
  }
  public update(id: string, data: Command): Promise<any> {
    throw new Error('Method not exists')
  }
  public delete(id: string): Promise<any> {
    throw new Error('Method not exists')
  }
  public getAll(...params: QueryConstraint[]): Promise<Command[]> {
    return this._getAll<Command>(...params);
  }
  public get(id: string): Promise<Command> {
    return this._get(id);
  }
  public on(listener: (data: Command[]) => void, ...params: QueryConstraint[]): Unsubscribe {
    return this._on(listener, ...params);
  }

}

export default CommandDB;